import React from 'react';
import styles from './styles.css';

const Banners = (props) => {
    if (props.noCredit) {
        return (
            <a href='https://estilonidera.com.ar' target='_blank' rel='noopener noreferrer' >
                <div className={styles.smallBanner} />
            </a>
        );
    }
    return (
        <div className={styles.splitBanners}>
            <div />
            <div />
        </div>
    );
};

export default Banners;



// WEBPACK FOOTER //
// ./components/banners/index.js